var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-detail-header"},[_c('Breadcrumb',{attrs:{"links":_vm.crumbs}}),_c('TabNav',{attrs:{"links":_vm.tabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }